// Home page component

import { CadastroFormPostal, initCadastroFormPostalEvents } from './CadastroFormPostal.js';

export async function HomePage() {

  const html = `

   
            <div class="relative">
              <div class="hero min-h-[70vh] bg-cover bg-center bg-fixed relative" 
                   style="background-image: linear-gradient(135deg, rgba(3, 128, 54, 0.85), rgba(0, 196, 94, 0.75)), url('/images/header.webp')">
                <div class="flex items-start justify-between w-full p-10">

                  <div class="text-left">
                    <h1 class="hero-title">Energy<br></br> Certificate?</h1>
                    <p class="hero-subtitlec flex-1 max-w-lg">Compare all advisors to get<br>the best deal!</p>

                    <ul class="mt-4 space-y-2 text-white" role="list" aria-label="Hero benefits">
                      <li class="flex items-center gap-3">
                        <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
                          <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                            <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span class="text-sm">Best price and fastest delivery guaranteed</span>
                      </li>

                      <li class="flex items-center gap-3">
                        <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
                          <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                            <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span class="text-sm">Compare certified advisors near you</span>
                      </li>

                      <li class="flex items-center gap-3">
                        <span class="inline-flex items-center justify-center w-6 h-6 bg-green-500 rounded-full flex-shrink-0">
                          <svg class="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                            <path d="M5 10l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </span>
                        <span class="text-sm">Free comparison – pay only upon receipt</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Form: overlay over hero background -->
            <div class="w-full max-w-full md:max-w-lg mx-auto z-20 mt-8 md:absolute md:top-0 md:left-1/2 md:transform md:-translate-x-1/2">
              ${CadastroFormPostal({ formId: 'home-desktop' })}
            </div>

            <section class="section bg-white py-16 bg-[url('/images/bg-groendak.svg')] bg-no-repeat bg-top bg-cover">

              <div class="container pt-32">
                <h2 class="text-4xl text-blue-900 mb-29 text-center">How does EPC Spain Homes work?</h2>
      
                <!-- Four-step visual summary -->
                <div class="max-w-6xl mx-auto mt-8">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 items-start">

                    <!-- Compare advisors -->
                    <div class="text-center">
                      <div class="relative w-20 h-16 mx-auto mb-4">
                        <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
                        <img src="/images/icon/zoeken.webp" alt="Search" class="relative w-8 h-8 mx-auto" />
                      </div>
                      <h3 class="text-lg font-semibold text-gray-900 mb-2">Compare advisors</h3>
                      <p class="text-gray-600">Independently compare all certified advisors by price, delivery time, and rating.</p>
                    </div>

                    <!-- Select your advisor -->
                    <div class="text-center">
                      <div class="relative w-20 h-16 mx-auto mb-4">
                        <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
                        <img src="/images/icon/selecteer.webp" alt="Select" class="relative w-8 h-8 mx-auto" />
                      </div>
                      <h3 class="text-lg font-semibold text-gray-900 mb-2">Select your advisor</h3>
                      <p class="text-gray-600">You pay only upon receipt and after the registration of the energy certificate (and optionally the improvement report).</p>
                    </div>

                    <!-- Sit back -->
                    <div class="text-center">
                      <div class="relative w-20 h-16 mx-auto mb-4">
                        <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
                        <img src="/images/icon/leun.webp" alt="Relax" class="relative w-8 h-8 mx-auto" />
                      </div>
                      <h3 class="text-lg font-semibold text-gray-900 mb-2">Relax</h3>
                      <p class="text-gray-600">The advisor arranges an appointment, visits your home, and prepares the energy certificate (and the optional report).</p>
                    </div>

                    <!-- Receive -->
                    <div class="text-center">
                      <div class="relative w-20 h-16 mx-auto mb-4">
                        <div class="absolute -rotate-6 bg-blue-200 w-20 h-12 rounded-xl top-0 left-1"></div>
                        <img src="/images/icon/ontvang.webp" alt="Receive" class="relative w-8 h-8 mx-auto" />
                      </div>
                      <h3 class="text-lg font-semibold text-gray-900 mb-2">Receive</h3>
                      <p class="text-gray-600">You will receive your energy certificate (and the optional report) by email, already officially registered.</p>
                    </div>

                  </div>
                </div>
              </div>
            </section>



                <div class="grid md:grid-cols-3 gap-8">
      




                  </div>

                </div>
              </div>
            </section>


    

    
            <!-- Our core values -->
            <section class="section bg-blue-900 text-white">
              <div class="container max-w-6xl mx-auto py-16">
                <h2 class="text-3xl font-semibold text-center text-white mb-8">Our <span class="italic">core values</span></h2>
                <div class="grid grid-cols-1 md:grid-cols-4 gap-8 text-left text-sm">

                  <div>
                    <div class="mb-4 text-center">
                      <img src="/images/icon/goedkoop.webp" alt="Affordable" class="w-8 h-8 mx-auto" />
                    </div>
                    <h3 class="font-semibold text-white mb-2 text-center">Affordable</h3>
                    <p class="text-white/90">Independently compare all certified advisors in your area by price, delivery time, and ratings. Take advantage of the best offers and competitive prices.</p>
                  </div>

                  <div>
                    <div class="mb-4 text-center">
                      <img src="/images/icon/snel.webp" alt="Fast" class="w-8 h-8 mx-auto" />
                    </div>
                    <h3 class="font-semibold text-white mb-2 text-center">Fast</h3>
                    <p class="text-white/90">Requesting an energy certificate has never been so easy and fast. In many cases, you will receive your certificate in just one business day.</p>
                  </div>

                  <div>
                    <div class="mb-4 text-center">
                      <img src="/images/icon/betrouwbaar.webp" alt="Reliable" class="w-8 h-8 mx-auto" />
                    </div>
                    <h3 class="font-semibold text-white mb-2 text-center">Reliable</h3>
                    <p class="text-white/90">Our team has many years of experience in the energy sector and ensures that all quotes, certifications, and registrations are done correctly.</p>
                  </div>

                  <div>
                    <div class="mb-4 text-center">
                      <img src="/images/icon/klantgericht.webp" alt="Customer-oriented" class="w-8 h-8 mx-auto" />
                    </div>
                    <h3 class="font-semibold text-white mb-2 text-center">Customer-oriented</h3>
                    <p class="text-white/90">We keep you informed of the latest news and are available for all your questions by phone, email, or WhatsApp.</p>
                  </div>

                </div>
              </div>
            </section>

            <!-- About energy certificates -->
            <section class="section bg-white py-16">
              <div class="container max-w-6xl mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

                  <div class="relative flex justify-center md:justify-start">
                    <div class="w-80 h-80 bg-green-300 transform -rotate-12 rounded-xl"></div>
                    <img src="/images/team/about-energy-labels.webp" alt="thumbs up" class="absolute w-72 -rotate-6 -left-6 top-6" />
                  </div>

                  <div class="prose max-w-none">
                    <h2 class="text-3xl font-bold text-green-700">About <span class="italic">energy certificates</span></h2>
                    <p class="text-green-700">Why does the energy certificate exist as we know it? It all has to do with global warming. That is why the energy certificate is a legal requirement. The Earth is warming due to greenhouse gas emissions such as CO₂, which largely come from our homes. To combat this, energy certificate regulations have been introduced.</p>
                    <p class="text-green-700">This way, the energy performance of your home is clearly displayed. The government's goal is to inform owners about the energy efficiency of their home or premises and motivate them to take saving measures such as insulation or installing solar panels.</p>
                    <a class="inline-block mt-4 bg-green-800 text-white py-2 px-4 rounded" href="/epc/">More about energy certificates →</a>
                  </div>

                </div>
              </div>
            </section>

            <!-- About improvement reports -->
            <section class="section bg-green-50 py-16">
              <div class="container max-w-6xl mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

                  <div class="prose max-w-none order-2 md:order-1">
                    <h2 class="text-3xl font-bold text-green-700">About <span class="italic">improvement reports</span></h2>
                    <p class="text-green-700">The improvement report is, as its name suggests, personalized advice for energy efficiency. A certified advisor identifies the specific measures that can improve the energy performance of your home or premises. This type of report is much more detailed than a simple "online scan".</p>
                    <p class="text-green-700">It can only be carried out by an authorized EP advisor and can be combined with an energy certificate. The certificate acts as the initial measurement and the improvement report tells you how to improve from that point.</p>
                    <a class="inline-block mt-4 bg-green-600 text-white py-2 px-4 rounded" href="/improvements-report/">More about improvement reports →</a>
                  </div>

                  <div class="relative flex justify-center md:justify-end order-1 md:order-2">
                    <div class="w-80 h-48 bg-green-200 transform rotate-12 rounded-xl"></div>
                    <img src="/images/team/about-custom-advise.webp" alt="energy advisor" class="w-72 -rotate-6 md:absolute md:right-0 md:top-3 relative mx-auto mt-4 md:mt-0" />
                  </div>

                </div>
              </div>
            </section>

            <!-- CTA section -->
            <section class="section bg-blue-600 text-white">
              <div class="container text-center">
                <h2 class="text-3xl font-bold mb-4">Ready to get your EPC certificate?</h2>
                <p class="text-xl mb-8 opacity-90">Transparent process, fixed prices, certified technicians</p>
                <div class="flex flex-col sm:flex-row gap-4 justify-center">
                  <button class="btn bg-white text-blue-600 hover:bg-gray-100" data-route="/cadastro/">Book certificate</button>
                  <button class="btn border-white text-white hover:bg-white hover:text-blue-600" data-route="/contact/">Ask a question</button>
                </div>
              </div>
            </section>

            <!-- About EPCSpainHomes -->
            <section class="section bg-maroon-800 text-white py-16">
              <div class="container max-w-6xl mx-auto">
                <div class="grid grid-cols-1 md:grid-cols-2 items-center gap-8">

                  <div class="relative flex justify-center md:justify-start">
                    <div class="w-80 h-52 bg-white transform -rotate-12 rounded-xl"></div>
                    <img src="/images/header1.webp" alt="building" class="absolute w-80 -rotate-6 left-0 top-6 rounded-xl" />
                  </div>

                  <div class="prose max-w-none">
                    <h2 class="text-3xl font-bold">We are <span class="italic">EPCspainhomes.com</span></h2>
                    <p>EPCspainhomes.com is an initiative of advisors with more than 20 years of experience in the energy market. Our team is ready to help you obtain your energy certificate (and optionally an improvement report) easily and quickly. We do this by showing all available advisors in your area and gathering all the information in one place.</p>
                    <p>We are dedicated to making difficult things easy. That is why our clients rate us with an average of 4.9 out of 5 stars. We are proud of this and it motivates us to continue offering the best service!</p>
                    <a class="inline-block mt-4 bg-white text-maroon-800 py-2 px-4 rounded" href="/about/">More about us →</a>
                  </div>

                </div>
              </div>
            </section>

            <!-- FAQ -->
            <section class="section bg-cream-100 py-16">
              <div class="container max-w-4xl mx-auto text-center">
                <h2 class="text-3xl font-semibold text-maroon-800 mb-8">
                  Frequently <span class="italic">asked questions</span> about the energy certificate
                </h2>

                <div class="space-y-4 text-left" id="faq-accordion">

                  <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
                    <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
                      <span>What is an energy certificate?</span>
                      <span class="accordion-icon text-2xl font-bold">+</span>
                    </button>
                    <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
                      <p>An energy certificate shows how efficient a home or premises is. It indicates the energy consumption for heating, hot water, ventilation, and cooling, with a scale from A (very efficient) to G (not very efficient).</p>
                    </div>
                  </div>

                  <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
                    <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
                      <span>Why request a certificate at EPCspainhomes.com?</span>
                      <span class="accordion-icon text-2xl font-bold">+</span>
                    </button>
                    <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
                      <p>At EPCspainhomes.com you can easily compare certified EP advisors by price, rating, and delivery time, to get a fast, affordable, and reliable certificate.</p>
                    </div>
                  </div>

                  <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
                    <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
                      <span>Why do I need an energy certificate?</span>
                      <span class="accordion-icon text-2xl font-bold">+</span>
                    </button>
                    <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
                      <p>It is mandatory when selling, renting, or handing over a home or premises. It informs potential buyers or tenants about the energy efficiency of the property.</p>
                    </div>
                  </div>

                  <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
                    <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
                      <span>Is an energy certificate mandatory?</span>
                      <span class="accordion-icon text-2xl font-bold">+</span>
                    </button>
                    <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
                      <p>Yes, it is mandatory for most homes and premises when selling, renting, or handing over the property. Not having one can result in fines.</p>
                    </div>
                  </div>

                  <div class="accordion-item border border-maroon-700 rounded overflow-hidden">
                    <button class="accordion-header flex justify-between items-center w-full bg-maroon-700 text-white p-4 text-left font-medium">
                      <span>What is the purpose of an energy certificate?</span>
                      <span class="accordion-icon text-2xl font-bold">+</span>
                    </button>
                    <div class="accordion-panel hidden bg-maroon-50 text-maroon-900 p-4">
                      <p>It provides information about the energy efficiency of the property and offers recommendations to improve it. A better certificate can increase the value of the property.</p>
                    </div>
                  </div>

                  <div class="mt-8 text-center">
                    <button onclick="location.href='/faq-customer/'" class="border border-maroon-700 text-maroon-700 py-2 px-6 rounded hover:bg-maroon-700 hover:text-white transition">Show more questions</button>
                  </div>

                </div>
              </div>
            </section>
            <!-- Advisor logos -->
            <section class="section bg-white py-16">
              <div class="container max-w-6xl mx-auto text-center">
                <h2 class="text-3xl font-semibold text-center mb-6">Advisors all over <span class="italic">Spain</span> to choose from.</h2>

                <div class="p-8 rounded-lg shadow-sm bg-white">
                  <div class="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
                    ${Array.from({ length: 24 })
                      .map((_, i) => {
                        const idx = i + 1;
                        const src =
                          idx >= 1 && idx <= 24
                            ? `/images/advisors/partner_logo_${idx}.webp`
                            : '/images/advisors/partner_label.webp';
                        return `
                      <div class="flex items-center justify-center p-4 bg-white border rounded-md">
                        <img src="${src}" alt="partner" class="max-h-16 object-contain opacity-90" />
                      </div>
                    `;
                      })
                      .join('')}
                  </div>

                  <div class="mt-8">
                    <a href="/advisors/" class="inline-block border border-blue-900 text-blue-900 py-2 px-6 rounded hover:bg-blue-900 hover:text-white transition">
                      All advisors →
                    </a>
                  </div>
                </div>
              </div>
            </section>
    `;

  // Na renderen: initialiseer het formulier (zorg dat het in de DOM staat)
  setTimeout(() => {
    try {
      initCadastroFormPostalEvents('home-desktop');
    } catch (e) {
      console.error('initCadastroFormPostalEvents faalde:', e);
    }
  }, 0);

  return html;
}
document.addEventListener("DOMContentLoaded", () => {
  const message = sessionStorage.getItem("homePopupMessage");

  if (message) {
    alert(message); // systeem popup
    sessionStorage.removeItem("homePopupMessage");
  }
});

if (typeof window !== "undefined" && !window.__faqAccordionActive) {
  window.__faqAccordionActive = true;

  document.addEventListener("click", (e) => {
    const header = e.target.closest(".accordion-header");
    if (!header) return;

    const item = header.closest(".accordion-item");
    const panel = item?.querySelector(".accordion-panel");
    const icon = header.querySelector(".accordion-icon");
    if (!item || !panel || !icon) return;

    const isOpen = header.getAttribute("aria-expanded") === "true";

    // Sluit andere items in dezelfde container
    const container = item.parentElement;
    container.querySelectorAll(".accordion-item").forEach((it) => {
      const h = it.querySelector(".accordion-header");
      const p = it.querySelector(".accordion-panel");
      const i = it.querySelector(".accordion-icon");
      if (!h || !p || !i) return;
      h.setAttribute("aria-expanded", "false");
      p.classList.add("hidden");
      i.textContent = "+";
    });

    // Toggle huidige item
    if (!isOpen) {
      header.setAttribute("aria-expanded", "true");
      panel.classList.remove("hidden");
      icon.textContent = "−"; // echt minteken
    } else {
      header.setAttribute("aria-expanded", "false");
      panel.classList.add("hidden");
      icon.textContent = "+";
    }
  });
}
